import FormattedMessage from 'I18n/components/FormattedMessage';
import { EmptyState } from 'foundations-components/transitional/components/EmptyState';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import MABEndTest from './MABEndTest';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MABNoData = ({
  canRenderMabEndTest,
  mabInfo
}) => {
  return /*#__PURE__*/_jsx(EmptyState, {
    primaryContent: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        useGap: true,
        message: "page-details-ui.testResults.personalization.mabNoData.body"
      }), canRenderMabEndTest && /*#__PURE__*/_jsx(MABEndTest, {
        mabExperiment: mabInfo.mabExperiment,
        variationsList: mabInfo.mabVariantsList
      })]
    }),
    secondaryContent: /*#__PURE__*/_jsx(Illustration, {
      name: "automated-testing",
      width: "100%"
    }),
    secondaryContentWidth: 200,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "page-details-ui.testResults.personalization.mabNoData.title"
    })
  });
};
export default MABNoData;